import { useMemo, useState } from "react";
import { useApartmentListForCourse, useAdminApartmentList } from "../../../assets/api/useAdminApi";
import useAuthStore from "../../../store/useAuthStore";

export const useApartmentOptions = (filters) => {



    const { user } = useAuthStore();

    const isRoleWithZoneFilter =
        user?.role === "Marketing Executive" ||
        user?.role === "Zonal Coordinator" ||
        user?.role === "Parent Counsellor"


    const isRoleWithCityFilter = user?.role === "Marketing Manager"
   const courseApartmentFilter = useMemo(() => {
    if (isRoleWithCityFilter) {
      return {
        city_id: user?.city_id,
      };
    }
    return {};
  }, [isRoleWithCityFilter, user?.city_id])
  
    /** -------------------------
     *  COURSE APARTMENT LIST
     * ------------------------- */
    const { data: apartmentList, isLoading: isLoadingCourseApartmentList } = useApartmentListForCourse(courseApartmentFilter);

    const userZoneNames = user?.zones?.map(z => z.zone_name) || [];

    const filteredApartmentsCourse = isRoleWithZoneFilter
        ? apartmentList?.data?.filter(apt =>
            userZoneNames.includes(apt.zone_name)
        ) || []
        : apartmentList?.data || [];

    const ApartmentOptionsCourse = filteredApartmentsCourse.map(item => ({
        id: item.id,
        label: item.apartment_name,
        value: item.apartment_name,
        ...item
    }));

    /** -------------------------
     *  ALL APARTMENTS LIST
     * ------------------------- */
    const { data: apartmentlist, isLoading: isLoadingAllApartmentList } =
        useAdminApartmentList(filters);

    const userZoneIds = user?.zones?.map(z => z?.id) || [];

    const filteredApartmentsAll = isRoleWithZoneFilter
        ? apartmentlist?.data?.filter(apt =>
            userZoneIds?.includes(apt?.zone_id)
        ) || []
        : apartmentlist?.data || [];

    const ApartmentOptionsAll = filteredApartmentsAll.map(item => ({
        id: item.id,
        label: item.apartment_name,
        value: item.apartment_name,
        ...item
    }));

    return {
        courseApartmentOption: {
            options: ApartmentOptionsCourse,
            isLoading: isLoadingCourseApartmentList
        },
        allApartmentOption: {
            options: ApartmentOptionsAll,
            isLoading: isLoadingAllApartmentList
        },
    };
};
